<div class="info-box">
  <div class="content">
    <p class="instruction-text">{{ information }}</p>
    <div class="download-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="115.425" height="140.899" viewBox="0 0 115.425 140.899" class="svg">
        <g id="download-file" transform="translate(-0.5 0)">
          <path
            id="Path_228"
            data-name="Path 228"
            d="M114.711,20.875,95.05,1.214A.628.628,0,0,0,95,1.166,4.139,4.139,0,0,0,92.12,0H18.8a4.144,4.144,0,0,0-4.144,4.143V88.318A28.153,28.153,0,1,0,52.438,127.8h59.343a4.143,4.143,0,0,0,4.143-4.144V23.805a4.145,4.145,0,0,0-1.214-2.93ZM96.263,14.147l5.485,5.485-5.485-.017ZM28.658,132.612a19.871,19.871,0,1,1,19.871-19.871A19.893,19.893,0,0,1,28.658,132.612Zm27.332-13.1A28.168,28.168,0,0,0,22.941,85.167V8.287H87.976V23.744a4.145,4.145,0,0,0,4.131,4.144l15.531.047v91.58Zm0,0"
            class="primary-fill"
          />
          <path
            id="Path_229"
            data-name="Path 229"
            d="M78.617,370.314a4.142,4.142,0,0,0-5.78-.959l-4.336,3.1V359.069a4.143,4.143,0,1,0-8.286,0v13.2L56.373,369.4a4.143,4.143,0,1,0-4.95,6.646l10.46,7.791a.077.077,0,0,0,.019.009,4.125,4.125,0,0,0,4.854.044s.01,0,.014-.005l10.89-7.792A4.142,4.142,0,0,0,78.617,370.314Zm0,0"
            transform="translate(-35.7 -257.253)"
            class="primary-fill"
          />
          <path
            id="Path_230"
            data-name="Path 230"
            d="M131.389,143.893h30.844a4.144,4.144,0,0,0,0-8.287H131.389a4.144,4.144,0,0,0,0,8.287Zm0,0"
            transform="translate(-91.866 -98.288)"
            class="primary-fill"
          />
          <path
            id="Path_231"
            data-name="Path 231"
            d="M181.293,195.828h-49.9a4.143,4.143,0,0,0,0,8.287h49.9a4.143,4.143,0,0,0,0-8.287Zm0,0"
            transform="translate(-91.866 -141.937)"
            class="primary-fill"
          />
          <path
            id="Path_232"
            data-name="Path 232"
            d="M181.293,256.055h-49.9a4.143,4.143,0,0,0,0,8.287h49.9a4.143,4.143,0,0,0,0-8.287Zm0,0"
            transform="translate(-91.866 -185.59)"
            class="primary-fill"
          />
        </g>
      </svg>
    </div>
    <button class="btn btn-outline-primary" (click)="onDownload()">Liste herunterladen</button>
  </div>
</div>
